import type { SVGProps } from "react";
export interface BadgePercentIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function BadgePercentIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: BadgePercentIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M8.656 2.585c1.69-2.355 5.282-2.276 6.846.236l.179.288.334-.076c2.882-.67 5.477 1.814 5.007 4.675l-.054.276-.078.333.29.182c2.593 1.614 2.593 5.388 0 7.003l-.29.179.078.334c.691 2.975-1.978 5.644-4.953 4.952l-.334-.077-.179.29c-1.614 2.592-5.389 2.592-7.003 0l-.182-.29-.332.077c-2.975.692-5.643-1.977-4.952-4.952l.077-.334-.289-.18c-2.593-1.614-2.593-5.388 0-7.002l.289-.182-.077-.333C2.342 5.01 5.01 2.342 7.985 3.034l.332.075.182-.288zm4.936 1.424a1.876 1.876 0 0 0-3.035-.207l-.148.207-.418.67c-.367.59-1.07.882-1.747.724l-.77-.178a1.874 1.874 0 0 0-2.25 2.25l.18.769a1.63 1.63 0 0 1-.517 1.595l-.207.152-.67.418a1.875 1.875 0 0 0 0 3.183l.67.417.207.153c.448.39.654 1 .517 1.593l-.18.77a1.875 1.875 0 0 0 2.25 2.25l.77-.178.255-.038a1.63 1.63 0 0 1 1.34.555l.152.207.418.67a1.875 1.875 0 0 0 3.183 0l.418-.67.152-.207a1.62 1.62 0 0 1 1.34-.555l.254.038.769.179.252.04a1.877 1.877 0 0 0 2.04-2.04l-.04-.252-.18-.769a1.62 1.62 0 0 1 .724-1.746l.67-.417a1.875 1.875 0 0 0 0-3.183l-.67-.418a1.625 1.625 0 0 1-.724-1.747l.18-.77.04-.25a1.876 1.876 0 0 0-2.292-2l-.77.18a1.63 1.63 0 0 1-1.593-.518l-.152-.206z"
      />
      <path
        fill={color}
        d="M14.705 7.705a1.125 1.125 0 0 1 1.591 1.59l-7 7a1.125 1.125 0 0 1-1.591-1.59zm-.205 6.924a.62.62 0 0 0-.124.37l.011.126c.019.091.06.173.113.245zm1 .741a.6.6 0 0 0 .112-.245l.013-.126-.013-.126a.6.6 0 0 0-.111-.244zm-7-6.741a.62.62 0 0 0-.124.37l.011.126c.019.091.06.173.113.245zm1 .741a.6.6 0 0 0 .112-.245L9.625 9l-.013-.126a.6.6 0 0 0-.111-.244v.741ZM16.627 15a1.625 1.625 0 0 1-3.242.167l-.009-.168.009-.165A1.625 1.625 0 0 1 15 13.374l.167.01a1.625 1.625 0 0 1 1.459 1.615Zm-6-6a1.625 1.625 0 0 1-3.242.167l-.009-.168.009-.165A1.625 1.625 0 0 1 9 7.374l.167.01a1.624 1.624 0 0 1 1.459 1.615Z"
      />
    </svg>
  );
}
